import type { SliceStateCreator } from "../../types";
import { messageDataActions } from "./messaging/messageDataActions";
import { messagePaginationActions } from "./messaging/messagePaginationActions";
import { messageUIActions } from "./messaging/messageUIActions";
import type { ChatRoomMessageActionsSliceState } from "./types";

export const createChatRoomMessageActionsSlice: SliceStateCreator<
  ChatRoomMessageActionsSliceState
> = (set, get) => ({
  messageActions: {
    ...messageDataActions(set, get),
    ...messagePaginationActions(set, get),
    ...messageUIActions(set),
  },
});
